/* eslint-disable no-console */
import React, { useEffect } from 'react';
import { AppShell } from '@mantine/core';
import bg from '../image/bg.svg';

function launchFullScreen() {
  const element = document.documentElement;
  if (element.requestFullscreen) {
    element.requestFullscreen().catch((err) => {
      console.log(err.message);
    });
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen().catch((err) => {
      console.log(err.message);
    });
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen().catch((err) => {
      console.log(err.message);
    });
  }
}

const MyApp = ({ children }) => {
  useEffect(() => {
    function disableRightClick(event) {
      event.preventDefault();
    }
    document.addEventListener('contextmenu', disableRightClick);
    return () => {
      document.removeEventListener('contextmenu', disableRightClick);
    };
  }, []);

  useEffect(() => {
    const launchOnUserGesture = () => {
      launchFullScreen();
    };
    document.addEventListener('click', launchOnUserGesture);
    return () => {
      document.removeEventListener('click', launchOnUserGesture);
    };
  }, []);

  return (
    <AppShell
      styles={() => ({
        root: {
          height: '100vh',
          backgroundImage: `url(${bg})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          overflow: 'hidden',
        },
        main: {
          padding: ' 0px',
          height: '100vh',
        },
      })}
    >
      {children}
    </AppShell>
  );
};

export default MyApp;
